// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"2270ae8f","883":"0ab6ce41"}[chunkId] + ".chunk.js";
};